import { Button } from '@kcd/design-system';

import { ChevronRightIcon } from '~/assets/icons';

import styles from './SwipeController.module.css';

interface Props {
  realIndex: number;
  totalPageIndex: number;
  visible: boolean;
  handlePrev: () => void;
  handleNext: () => void;
}
const SwipeController = ({
  realIndex,
  totalPageIndex,
  visible,
  handlePrev,
  handleNext,
}: Props) => {
  return (
    <div className="mt-24 flex items-center justify-center px-20">
      {visible && (
        <Button size="lg" className={styles.button} onClick={handlePrev}>
          <ChevronRightIcon className="inline-block rotate-180" />
        </Button>
      )}
      <span className={styles.text}>
        <span className={styles.index}>{realIndex + 1}</span>
        <span> / </span>
        <span className={styles.total}>{totalPageIndex}</span>
      </span>
      {visible && (
        <Button size="lg" className={styles.button} onClick={handleNext}>
          <ChevronRightIcon className="inline-block" />
        </Button>
      )}
    </div>
  );
};

export default SwipeController;
